import React, { useState, useEffect, useRef } from 'react';
import Image from '../../components/Image/Image';
import Ribbon from '../../components/product-list/ribbon';
/*import Modal from '../../components/Modal/Modal';
import Button from '../../components/form-elements/Button';
import Anchor from '../../components/form-elements/Anchor'; */
import { Swiper, SwiperSlide } from 'swiper/react';
// eslint-disable-next-line import/no-unassigned-import
import 'swiper/swiper-bundle.min.css';
import SwiperCore, { Navigation, Pagination, A11y } from 'swiper';
import MerklisteButton from '../Merkliste/MerklisteButton';
import { InternalLink } from '../../components/form-elements/Link';

function ProductImages(props) {
    SwiperCore.use([Navigation, Pagination, A11y]);
    const { variant, images, isOfferActive, linkedTo } = props;

    const replacedimages = [];
    const isOwnArticle = variant?.isOwnArticle;
    const isReifenCategory = variant?.categories?.[0] === "reifen";
    const productID = isOwnArticle
        ? variant?._id
        : isReifenCategory
            ? variant?.neutralKey
            : variant?.id || variant?._id;

    const categoryUrl = variant?.category?.[0] || variant?.categories?.[0];

    const [isMobile, setIsMobile] = useState(true);

    const swiperRef = useRef(null);
    const handleKeyDown = (e) => {
        if (!swiperRef.current) return;
        const swiper = swiperRef.current.swiper;
        if (e.key === "ArrowRight") {
            swiper.slideNext();
            e.preventDefault();
        }
        if (e.key === "ArrowLeft") {
            swiper.slidePrev();
            e.preventDefault();
        }
    };

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 640);
        };

        handleResize();

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    let image;

    images.forEach(element => {
        if (element.includes('techno-images.s3.eu-central-1.amazonaws.com')) {
            replacedimages.push(element.replace(/%20| /g, '+'))
        } else if (element.includes('technoshopautohaus.blob.core.windows.net') && !element.includes('.jpg') && !element.includes('.png')) {
            let image_url = element.replace('https://technoshopautohaus.blob.core.windows.net', 'https://techno-images.s3.eu-central-1.amazonaws.com');
            image = `${image_url}.jpg`;
            replacedimages.push(image);
        } else if (element.includes('technoshopautohaus.blob.core.windows.net') && element.includes('.jpg')) {
            let image_url = element.replace('https://technoshopautohaus.blob.core.windows.net', 'https://techno-images.s3.eu-central-1.amazonaws.com');
            replacedimages.push(image_url);
        } else if (element.includes('technoshopautohaus.blob.core.windows.net') && element.includes('.png')) {
            let image_url = element.replace('https://technoshopautohaus.blob.core.windows.net', 'https://techno-images.s3.eu-central-1.amazonaws.com');
            replacedimages.push(image_url);
        } else {
            replacedimages.push(element);
        }
    });


    /* if (!images.length) return <div />; */

    return (
        <div data-uk-margin="">
            <div className="uk-width-1-1 uk-margin-auto uk-position-relative" tabIndex={0} onKeyDown={handleKeyDown} aria-label="Bilderkarussell. Mit den Pfeiltasten navigieren." role="region" aria-roledescription="Karussell">
                <Swiper
                    spaceBetween={0}
                    slidesPerView={1}
                    navigation={{
                        prevEl: '.swiper-button-prev',
                        nextEl: '.swiper-button-next',
                    }}
                    pagination={{
                        clickable: true, el: '.custom-pagination',
                        renderBullet: (index, className) => {
                            return `
                                <button
                                    type="button"
                                    class="${className}"
                                    role="tab"
                                    aria-label="Gehe zu Slide ${index + 1}"
                                ></button>
                                `;
                        }
                    }
                    }
                    centeredSlides={true}
                    ref={swiperRef}
                    a11y={{
                        prevSlideMessage: 'Vorheriger slide',
                        nextSlideMessage: 'Nächster slide',
                    }}
                >
                    <button
                        type='button'
                        className="swiper-button-prev"
                    />
                    <button
                        type='button'
                        className="swiper-button-next"
                    />
                    <Ribbon product={variant} isOfferActive={isOfferActive} />
                    <MerklisteButton productId={productID} categoryUrl={categoryUrl} selectedVariant={productID} />
                    {replacedimages.length > 0 ? replacedimages.map((image, i) => (
                        <SwiperSlide key={i} className='uk-flex uk-flex-middle uk-flex-center uk-border uk-border-muted' role="group" aria-roledescription="Bild" aria-label={`Bild ${i + 1} von ${replacedimages.length}`}>
                            {isMobile ?

                                (linkedTo ?
                                    <InternalLink to={linkedTo} tabIndex={-1} ariaLabel={`${variant?.imagesList?.[i]?.alt} ${i + 1}` ?? `Zum Produkt`}>
                                        <Image
                                            src={image}
                                            alt={`${variant?.imagesList?.[i]?.alt} ${i + 1}` ?? `Produktbild${i + 1}`}
                                            className="uk-width-auto uk-responsive-width product-image--maxHeight"
                                            resizeHeight={300}
                                            resizeWidth={300}
                                            fit="inside"
                                        />
                                    </InternalLink>
                                    :
                                    <Image
                                        src={image}
                                        alt={`${variant?.imagesList?.[i]?.alt} ${i + 1}` ?? `Produktbild${i + 1}`}
                                        className="uk-width-auto uk-responsive-width product-image--maxHeight"
                                        resizeHeight={300}
                                        resizeWidth={300}
                                        fit="inside"
                                    />
                                )
                                :

                                (linkedTo ?
                                    <InternalLink to={linkedTo} tabIndex={-1} ariaLabel={`${variant?.imagesList?.[i]?.alt} ${i + 1}` ?? `Zum Produkt`}>
                                        <Image
                                            src={image}
                                            alt={`${variant?.imagesList?.[i]?.alt} ${i + 1}` ?? `Produktbild${i + 1}`}
                                            className="uk-width-auto uk-responsive-width product-image--maxHeight"
                                            resizeHeight={450}
                                            resizeWidth={450}
                                            fit="inside"
                                        />
                                    </InternalLink>
                                    :
                                    <Image
                                        src={image}
                                        alt={`${variant?.imagesList?.[i]?.alt} ${i + 1}` ?? `Produktbild${i + 1}`}
                                        className="uk-width-auto uk-responsive-width product-image--maxHeight"
                                        resizeHeight={450}
                                        resizeWidth={450}
                                        fit="inside"
                                    />
                                )
                            }

                            {/*  <div className="uk-position-bottom-right uk-position uk-padding-small uk-border uk-border-muted bookmark-icon" style={{ background: '#f1f1f1' }}>
                                <i class="fa fa-fw fa-light fa-heart-o "></i>
                                {/* <i className="fa fa-fw fa-search-plus fa-2x" style={{ width: '1em' }} /> 
                            </div> */}
                            {/* <Button
                                fullWidth
                                modifier="link"
                                className="uk-flex uk-flex-middle uk-flex-center uk-height-1-1"
                                onClick={() => toggleBigImage(i)}
                            >

                            {/*  <div className="uk-position-bottom-right uk-position uk-padding-small uk-border uk-border-muted bookmark-icon" style={{ background: '#f1f1f1' }}>
                                <i class="fa fa-fw fa-light fa-heart-o "></i>
                                <i className="fa fa-fw fa-search-plus fa-2x" style={{ width: '1em' }} />
                            </div> */}
                        </SwiperSlide>
                    )) :
                        <SwiperSlide className='uk-flex uk-flex-middle uk-flex-center uk-border uk-border-muted'>
                            {linkedTo ?
                                <InternalLink to={linkedTo} tabIndex={-1}>
                                    <Image src="" alt={variant.bezeichnung} resizeHeight={235} fit="cover" />
                                </InternalLink>
                                : <Image src="" alt={variant.bezeichnung} resizeHeight={235} fit="cover" />
                            }
                        </SwiperSlide>}
                </Swiper>
                <div className="custom-pagination uk-position-relative uk-flex uk-flex-center" role="tablist"/>
            </div>
        </div>
    );
}

export default ProductImages;
